import { MouseEvent } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

type TabProps = {
  label: string;
  onClick: (e: MouseEvent) => void;
  onContextMenu?: (e: MouseEvent) => void;
  index: number;
  activeTabIndex: number;
};

export const Tab = ({
  label,
  onClick,
  onContextMenu,
  index,
  activeTabIndex,
}: TabProps) => {
  const isActive = index === activeTabIndex;

  return (
    <button
      className={clsx(styles.tab, {
        [styles.active]: isActive,
      })}
      role="tab"
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      {label}
    </button>
  );
};
